import React from 'react';
import ReactDOM from 'react-dom/client';

// ✅ Slick Carousel CSS — ADD THESE TWO LINES
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import './index.css';
import './styles/mobile-spacing.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
